import { makeAutoObservable, action, runInAction } from "mobx";
import { rootStore } from "../../store/rootStore";
class FilterStore {
  rootStore;
  isMenuOpen = false;
  anchorEl = null;
  selectedFilters = new Set();
  fetchedOptions = [];
  isLoading = false;
  error = null;
  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, {
      toggleMenu: action,
      closeMenu: action,
      handleCheckboxChange: action,
      setAnchorEl: action,
      // fetchOptions: action,
    });
  }
  setAnchorEl = (el) => {
    runInAction(() => {
      this.anchorEl = el;

    })
  };
  toggleMenu = () => {
    runInAction(() => {
      this.isMenuOpen = !this.isMenuOpen;
    })
  };
  closeMenu = () => {
    runInAction(() => {
      this.isMenuOpen = false;
      this.anchorEl = null;
    })

  };
  async fetchOptions(user, type = "business") {
    
    runInAction(() => {
      this.isLoading = true;
      this.error = null;
    })

    try {
      // Ensure the user object is passed correctly
      const response = await rootStore.commonAxios(
        `/getFuzzyColumns?type=${type}`,
        "GET",
        {
          // Pass the userId if the user object exists
        },
        {},
        {
          "Content-Type": "application/json",
        }
      );
      // Store the fetched options
      runInAction(() => {
        this.fetchedOptions = response?.data?.list || [];
        this.selectedFilters = new Set(
          this.fetchedOptions.map((option) => option.value));
      })
      // Safely handle response data
    } catch (err) {
      runInAction(() => {
        this.error = "Failed to fetch options";

      })
    } finally {
      runInAction(() => {
        this.isLoading = false;
      })
    }
  }
  handleCheckboxChange = (filter) => {
    if (this.selectedFilters.has(filter)) {
      runInAction(() => {
        this.selectedFilters.delete(filter);
      })
    } else {
      runInAction(() => {
        this.selectedFilters.add(filter);
      })
    }
    runInAction(() => {
      this.selectedFilters = new Set(this.selectedFilters); // trigger reactivity
    })
  };
}
export default FilterStore;
